"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCatalystRegistrationNonce = exports.serializeCatalystRegistrationRewardsDestination = exports.serializeCatalystRegistrationStakingPath = exports.serializeCatalystRegistrationVotingKey = void 0;
const serialize_1 = require("../../utils/serialize");
const addressParams_1 = require("./addressParams");
function serializeCatalystRegistrationVotingKey(votingPublicKey) {
    return Buffer.concat([
        serialize_1.hex_to_buf(votingPublicKey),
    ]);
}
exports.serializeCatalystRegistrationVotingKey = serializeCatalystRegistrationVotingKey;
function serializeCatalystRegistrationStakingPath(stakingPath) {
    return Buffer.concat([
        serialize_1.path_to_buf(stakingPath),
    ]);
}
exports.serializeCatalystRegistrationStakingPath = serializeCatalystRegistrationStakingPath;
function serializeCatalystRegistrationRewardsDestination(rewardsDestination, version) {
    return Buffer.concat([
        addressParams_1.serializeAddressParams(rewardsDestination, version),
    ]);
}
exports.serializeCatalystRegistrationRewardsDestination = serializeCatalystRegistrationRewardsDestination;
function serializeCatalystRegistrationNonce(nonce) {
    return Buffer.concat([
        serialize_1.uint64_to_buf(nonce),
    ]);
}
exports.serializeCatalystRegistrationNonce = serializeCatalystRegistrationNonce;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2F0YWx5c3RSZWdpc3RyYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaW50ZXJhY3Rpb25zL3NlcmlhbGl6YXRpb24vY2F0YWx5c3RSZWdpc3RyYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEscURBQThFO0FBQzlFLG1EQUF3RDtBQUV4RCxTQUFnQixzQ0FBc0MsQ0FBQyxlQUF3QztJQUMzRixPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFDakIsc0JBQVUsQ0FBQyxlQUFlLENBQUM7S0FDOUIsQ0FBQyxDQUFBO0FBQ04sQ0FBQztBQUpELHdGQUlDO0FBRUQsU0FBZ0Isd0NBQXdDLENBQUMsV0FBMkI7SUFDaEYsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ2pCLHVCQUFXLENBQUMsV0FBVyxDQUFDO0tBQzNCLENBQUMsQ0FBQTtBQUNOLENBQUM7QUFKRCw0RkFJQztBQUVELFNBQWdCLCtDQUErQyxDQUMzRCxrQkFBdUMsRUFDdkMsT0FBZ0I7SUFFaEIsT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ2pCLHNDQUFzQixDQUFDLGtCQUFrQixFQUFFLE9BQU8sQ0FBQztLQUN0RCxDQUFDLENBQUE7QUFDTixDQUFDO0FBUEQsMEdBT0M7QUFFRCxTQUFnQixrQ0FBa0MsQ0FBQyxLQUFpQjtJQUNoRSxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFDakIseUJBQWEsQ0FBQyxLQUFLLENBQUM7S0FDdkIsQ0FBQyxDQUFBO0FBQ04sQ0FBQztBQUpELGdGQUlDIn0=